// Firebase configuration for Qwipe React App
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: 'AIzaSyBcNODRAg9s0Df5SUloLkySmqSldyOPgUQ',
  authDomain: 'qwipesystem.firebaseapp.com',
  projectId: 'qwipesystem',
  storageBucket: 'qwipesystem.firebasestorage.app',
  messagingSenderId: '42353476302',
  appId: '1:42353476302:web:6c60c1795b8205e846469f'
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

export default app;
